var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoryUnSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8947 0L4.23684 10.8H17.5526L10.8947 0ZM10.8947 4.608L13.2311 8.4H8.54632L10.8947 4.608ZM17.5526 13.2C14.5384 13.2 12.1053 15.612 12.1053 18.6C12.1053 21.588 14.5384 24 17.5526 24C20.5668 24 23 21.588 23 18.6C23 15.612 20.5668 13.2 17.5526 13.2ZM17.5526 21.6C15.8821 21.6 14.5263 20.256 14.5263 18.6C14.5263 16.944 15.8821 15.6 17.5526 15.6C19.2232 15.6 20.5789 16.944 20.5789 18.6C20.5789 20.256 19.2232 21.6 17.5526 21.6ZM0 23.4H9.68421V13.8H0V23.4ZM2.42105 16.2H7.26316V21H2.42105V16.2Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryUnSelected);
export default __webpack_public_path__ + "static/media/CategoryUnSelected.e2e83e40b64a8de9c9b8212986abbfd3.svg";
export { ForwardRef as ReactComponent };